import { getWithAuth } from '../api';

/**
 * Load Google Maps API dynamically using the API key from config endpoint.
 */
export async function loadGoogleMaps(apiKey = null) {
  try {
    // Check if Google Maps is already loaded
    if (window.google && window.google.maps) {
      return Promise.resolve();
    }

    let resolvedApiKey = apiKey;
    if (!resolvedApiKey) {
      const response = await getWithAuth('config/google_keys');
      resolvedApiKey = response?.google_tile_key;
    }

    if (!resolvedApiKey) {
      console.error('Google Tile Key not found in config');
      return Promise.reject(new Error('Google Tile Key not found'));
    }

    const region = window.localStorage.getItem('mapRegion') || 'us';
    let language = navigator.language || 'en';
    if (language.includes('-')) {
      language = language.split('-')[0];
    }
    const url = `https://maps.googleapis.com/maps/api/js?key=${resolvedApiKey}&language=${language}&region=${region}`;

    return new Promise((resolve, reject) => {
      // Check if script is already being loaded
      const existingScript = document.querySelector(`script[src^="https://maps.googleapis.com/maps/api/js"]`);
      if (existingScript) {
        // If script exists, wait for it to load
        existingScript.addEventListener('load', resolve);
        existingScript.addEventListener('error', reject);
        return;
      }

      const script = document.createElement('script');
      script.src = url;
      script.defer = true;

      script.onload = () => {
        resolve();
      };

      script.onerror = () => {
        reject(new Error('Failed to load Google Maps script'));
      };

      document.head.appendChild(script);
    });
  } catch (error) {
    console.error('Failed to load Google Maps from config key:', error);
    return Promise.reject(error);
  }
}
